import React, { useState } from 'react';

// Shared "Notes" row: shows the latest note (click to open history) + inline composer with Save
export const NotesRow = ({ lastNote, onOpenNotes, onSaveNote, testId = 'lw-notes' }) => {
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!draft.trim() || saving) return;
    setSaving(true);
    try {
      await onSaveNote(draft.trim());
      setDraft('');
    } finally {
      setSaving(false);
    }
  };

  const when = lastNote?.created_at ? new Date(lastNote.created_at).toLocaleString('en-US', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <>
      <div className="lw-row" style={{ alignItems: 'flex-start' }}>
        <span className="lw-link" style={{ width: 95, paddingTop: 4 }} onClick={onOpenNotes} data-testid={`${testId}-link`}>Notes:</span>
        <div
          className="lw-input"
          onClick={onOpenNotes}
          title="Click to view all notes"
          style={{ flex: 1, minHeight: 28, height: 'auto', padding: '4px 8px', cursor: 'pointer', fontSize: 12.5, lineHeight: 1.3, background: '#f6f7fb' }}
          data-testid={`${testId}-last`}
        >
          {lastNote ? (
            <>
              <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{lastNote.content}</div>
              <div style={{ fontSize: 10.5, color: 'var(--lw-muted)', marginTop: 2 }}>{lastNote.created_by_name || 'User'} · {when}</div>
            </>
          ) : (
            <span style={{ color: 'var(--lw-muted)' }}>No notes yet — click to view history</span>
          )}
        </div>
      </div>
      <div className="lw-row" style={{ alignItems: 'flex-start' }}>
        <span className="lw-label" style={{ width: 95 }} />
        <textarea
          className="lw-input"
          rows={2}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) save(); }}
          placeholder="Write a note..."
          style={{ flex: 1, height: 'auto', padding: '4px 8px' }}
          data-testid={`${testId}-input`}
        />
        <button
          className="lw-btn"
          onClick={save}
          disabled={!draft.trim() || saving}
          style={draft.trim() ? { background: 'var(--lw-red)', borderColor: 'var(--lw-red)', color: '#fff', height: 28 } : { height: 28, opacity: 0.6 }}
          data-testid={`${testId}-save`}
        >
          {saving ? 'Saving…' : 'Save'}
        </button>
      </div>
    </>
  );
};
